/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([], () => {
	/**
	 * @interface ContentTypeRegistryAPI
	 * @classdesc public API interface that is used to register content type spec and create them
	 */
	class ContentTypeRegistryAPI {
		/**
		 * @public
		 * @function ContentTypeRegistry#getRegisteredTypes
		 * @description Get names of registered content types
		 * @returns {Array} Array of registered types
		 */
		getRegisteredTypes() {}

		/**
		 * @public
		 * @function ContentTypeRegistry#getContentFeatures
		 * @description Get features of registered content types
		 * @returns {Array} Array of features for registered content types
		 */
		getContentFeatures() {}

		/**
		 * @public
		 * @function ContentTypeRegistry#getExposedContents
		 * @description Get registered content types that has expose set to true and updates the spec
		 * @returns {Array} Array of filtered content types
		 */
		getExposedContents() {}

		/**
		 * @public
		 * @function ContentTypeRegistry#isTypeRegistred
		 * @description check a type is registered by contentType
		 * @param {string} type - type of content to check
		 * @returns {boolean} true if the type registered, otherwise false
		 */
		isTypeRegistered() {}

		/**
		 * @public
		 * @function ContentTypeRegistry#isTypeRegistred
		 * @description Process content feature collection
		 * This method does 2 things:
		 * - appends the custom features into the collection
		 * - adds features to the custom types that need them
		 * @param {Array} collection - feature collection to process
		 * @returns {Array} processed feature collection
		 */
		processFeatureCollection() {}

	}
	return ContentTypeRegistryAPI;
});